<i nz-icon [nzType]="icon" [nzTheme]="theme"></i>
